var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.loading)?_c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{staticClass:"config",attrs:{"locale":_vm.locale}},[_c('transition',{attrs:{"name":"router"}},[_c('router-view')],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }